<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="系统编号">
              <a-input v-model="queryParam.number" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="采销全流程">
              <a-select
                show-search
                allow-clear
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="进出口类型">
              <a-select
                allow-clear
                placeholder="选择"
                v-model="queryParam.import_export_type"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.filteredTradeTypes">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" v-if="false">
            <a-form-item label="创建人">
              <a-input v-model="queryParam.create_by" placeholder="创建人" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="approval_needed" slot-scope="text, item">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(item, undefined, false)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="guarantee_period" slot-scope="text, record">
        {{ record.guarantee_period_start_date !== '1970-01-01' ? record.guarantee_period_start_date + '~' : '' }} {{ record.guarantee_period_end_date !== '1970-01-01' ? record.guarantee_period_end_date: '' }}
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleWatchView(record)">预览</a>
          <a-divider type="vertical" v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"
            title="确定重启审批?"
            @confirm="() => approvalNeeded(record, 'customs_declaration_contract', true)">
            <span>重启审批</span>
          </a-popconfirm>
          <a-divider type="vertical"/>
          <a @click="handleEdit(record)" v-if="!record.is_archived && isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="!record.is_archived && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="!record.is_archived && isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="!record.is_archived && isEdited(record.create_by_id)"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleAttachment(record)">附件</a>
              </a-menu-item>
              <a-menu-item v-if="record.version > 1">
                <a @click="handleModifyRecord(record)">查看修改</a>
              </a-menu-item>
              <a-menu-item v-if="false">
                <a @click="handleCopy(record)">复制合同</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>
    <contract-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <guarantee-contract-record :contract="mdl" :visible="recordVisible" @close="recordVisible=false" v-if="recordVisible"/>
    <watch-view-form :model="mdl" :visible="watchViewVisible" @cancel="watchViewVisible=false" v-if="watchViewVisible"/>
  </div>
</template>

<script>
import { STable } from '@/components'
import ContractForm from '../modules/ContractForm'
import WatchViewForm from '../modules/WatchViewForm'
import GuaranteeContractRecord from '../../project/modules/GuaranteeContractRecord'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'
import {
  customs_declaration_contract_create, customs_declaration_contract_delete,
  customs_declaration_contract_list, customs_declaration_contract_update
} from '@/api/trade_customs_declaration_contract'

export default {
  name: 'TableList',
  components: {
    STable,
    ContractForm,
    GuaranteeContractRecord,
    WatchViewForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archivedVisible: false,
      recordVisible: false,
      watchViewVisible: false,
      projectFetching: false,
      projectList: [],
      mdl: {},
      // 查询参数
      queryParam: {
        filter: true
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '系统编号',
          dataIndex: 'number',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 180,
          ellipsis: true
        },
        {
          title: '购销合同',
          dataIndex: 'sell_contract',
          width: 250,
          ellipsis: true
        },
        {
          title: '进出口类型',
          dataIndex: 'import_export_type',
          width: 150,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_types[text] || ''
        },
        {
          title: '被委托方',
          dataIndex: 'trustee',
          width: 200,
          ellipsis: true
        },
        {
          title: '提单号',
          dataIndex: 'bill_lading_number',
          width: 150,
          ellipsis: true
        },
        {
          title: '收费标准',
          dataIndex: 'charging_standard',
          width: 150,
          ellipsis: true
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return customs_declaration_contract_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      optionAlertShow: false
    }
  },
  created () {
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    },
    filteredTradeTypes () {
      return Object.fromEntries(
        Object.entries(this.$Dictionaries.trade_types).filter(([k]) => ['2', '3'].includes(k))
      )
    }
  },
  methods: {
    handleAdd () {
      const date = new Date()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: date.getFullYear() + '' + (date.getMonth() + 1) + date.getDate() + hours + minutes }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archivedVisible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleCopy (record) {
      this.$router.push({ path: '/trade/customs_declaration_contract/' + record.id + '/copy' })
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/customs_declaration_contract/' + record.id })
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/customs_declaration_contract/' + record.id + '/attachment', query: { record: record.name } })
    },
    handleWatchView (record) {
      this.mdl = record
      this.watchViewVisible = true
    },
    handleDelete (record) {
      customs_declaration_contract_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleModifyRecord (record) {
      // 查看修改记录
      this.mdl = record
      this.recordVisible = true
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        customs_declaration_contract_update({ is_approval_needed: true }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        })
      }
    },
    archived (record) {
      customs_declaration_contract_update({ is_archived: !record.is_archived }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          this.confirmLoading = true
          values['guarantee_period'] = undefined
          values['guarantee_period_start_date'] = data['guarantee_period_start_date']
          values['guarantee_period_end_date'] = data['guarantee_period_end_date']
          values['attachment'] = data['attachment']
          customs_declaration_contract_create(values).then(res => {
            if (res.code === 1000) {
              // 刷新表格
              this.$refs.table.refresh()
              this.visible = false
              // 重置表单数据
              form.resetFields()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    }
  }
}
</script>
